// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__58tS9","col":"styles_col__op7sB","fulfillmentStatus":"styles_fulfillmentStatus__2PN_d","emailCol":"styles_emailCol__1aLoe"};